import { useState } from "react";

export default function useToggle(def: boolean): [boolean, () => void] {
    const [state, setState] = useState(def)
    const toggle = () => setState(!state)
    return [state, toggle]
}